import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { mainReducer } from "./redux/mainReducer";
import { applyMiddleware, createStore } from "redux";

const store = createStore(mainReducer, applyMiddleware(thunk));
const root = ReactDOM.createRoot(document.getElementById("calc-app"));
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </Provider>,
);
reportWebVitals();
